import {createRequestDataSource} from '@ngneat/elf-requests';
import {select} from '@ngneat/elf';

import {sessionStore} from '@store/session/session.store';

export const getCurrentUserDataSource = createRequestDataSource({
  store: sessionStore,
  data$: () => sessionStore.pipe(
    select((state) => state.user),
  ),
  requestKey: 'getCurrentUser',
  dataKey: 'currentUser',
});